export const LANDLINE = '(03)85245960'
export const MOBILE = '0430352667'
export const ADDR = '13 Treforest Drive, Clayton, VIC 3168'
export const EMAIL = '13sfauto@gmail.com'
export const START_HOUR= '8:30 AM'
export const END_HOUR = '5:00 PM'